function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.91846 3.72974H3.85938V7.07657H8.91846V3.72974Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.91846 8.75415H3.85938V12.101H8.91846V8.75415Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.91846 13.7747H3.85938V17.1212H8.91846V13.7747Z",
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M18.2627 3.72974H13.2036V7.07657H18.2627V3.72974Z",
  fill: "currentColor"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M18.2627 8.75415H13.2036V12.101H18.2627V8.75415Z",
  fill: "currentColor"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M18.2627 13.7747H13.2036V17.1212H18.2627V13.7747Z",
  fill: "currentColor"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M27.6063 3.72974H22.5469V7.07657H27.6063V3.72974Z",
  fill: "currentColor"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M36.9495 3.72974H31.8901V7.07657H36.9495V3.72974Z",
  fill: "currentColor"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M27.6063 8.75415H22.5469V12.101H27.6063V8.75415Z",
  fill: "currentColor"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M36.9703 0.527832H3.02971C1.35907 0.527832 0 1.87981 0 3.54203V28.347C0 30.0095 1.35907 31.3612 3.02971 31.3612H36.97C38.6412 31.3612 40 30.0092 40 28.347V3.54203C40.0003 1.87981 38.6412 0.527832 36.9703 0.527832ZM20.3789 2.03493H29.243V29.8541H20.3789V2.03493ZM19.6217 29.8541H10.7573V2.03493H19.6214L19.6217 29.8541ZM1.51501 28.347V3.54203C1.51501 2.71076 2.19439 2.03493 3.03002 2.03493H10.0001V29.8541H3.02971C2.19439 29.8541 1.51501 29.1776 1.51501 28.347ZM38.4853 28.347C38.4853 29.1779 37.8053 29.8544 36.97 29.8544H30.0005V2.03493H36.9703C37.8056 2.03493 38.4856 2.71076 38.4856 3.54203L38.4853 28.347Z",
  fill: "currentColor"
});

var SvgIcSidemenuKanban = function SvgIcSidemenuKanban(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcSidemenuKanban, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_sidemenu_kanban.46f07638.svg";
export { ForwardRef as ReactComponent };